import dayjs from 'dayjs';
export const FORM_SEARCH = ({ onEnter }) => {
  return [
    {
      name: 'search',
      type: 'INPUT',
      label: 'ค้นหารายการ (กรอกข้อมูลแล้วกด Enter เพื่อค้นหา)',
      helper:
        'Tips : ช่องค้นหารายการ สามารถค้นหาด้วย รหัสรับประกัน, เบอร์ , รหัสลูกค้า , ชื่อลูกค้า',
      span: 16,
      onEnter,
    },
    {
      name: 'startDate',
      label: 'ค้นหาผ่านวันที่ลงทะเบียน',
      type: 'DATE_RANGE',
      placeholder: '',
      span: 8,
      rules: {
        required: true,
      },
    },
  ];
};

export const searchDefaultValues = {
  search: '',
  startDate: [dayjs().subtract(7, 'day'), dayjs()],
};
